import axios from "axios";
import config from "../config";
import _ from "lodash";
import { checkUserAuthState } from "./auth";
import router from "../router";

const apiAxios = axios.create({
    baseURL: config.apiHost,
    withCredentials: true,
});

/**
 * Redirect to the Login view if the server returns a 401
 */
apiAxios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (_.get(error, "response.status") === 401) {
            const path = _.get(error, "response.config.url");
            if (path && !path.startsWith("/auth")) {
                // At this point an API call was made and the user was no longer logged in. Calling checkUserAuthState
                // will check the session and clear the client side auth state.
                checkUserAuthState().then(({ isAuthenticated }) => {
                    if (!isAuthenticated) {
                        // Show the home page with the login button
                        router.push({ name: "Home" });
                    }
                });
            }
        }

        return Promise.reject(error);
    }
);

export default apiAxios;
